<template>
  <div class="answerCommentaryItem">
    <h3>問題{{ data.qno }}</h3>
    <div class="question">{{ data.question }}</div>
    <div class="img">
      <img
        v-for="(item, index) in data.question_images"
        :key="index"
        :src="item.url"
        alt=""
      />
    </div>
    <div class="result" :class="isCorrect() ? '-correct' : '-incorrect'">
      <div class="icon"></div>
      <span>{{ isCorrect() ? '正解' : '不正解' }}</span>
    </div>
    <div class="answers">
      <div class="correct">正解は「{{ correctAnswerText() }}」</div>
      <div class="answer">あなたの回答：{{ data.answer.toUpperCase() }}</div>
    </div>
    <div class="accordions">
      <CbtAccordion v-for="item in accordionTexts" :key="item" :data="item" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import CbtAccordion from '@/components/block/CbtAccordion.vue'

export default defineComponent({
  name: 'CbtAnswerCommentaryItem',
  components: {
    CbtAccordion
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },

  setup(props) {
    const isCorrect = () => {
      const correctAnswer = props.data.answers.find(
        (key: any) => key.right_flag === true
      )
      return correctAnswer.answer_check === props.data.answer
    }
    const correctAnswerText = () => {
      const correctAnswer = props.data.answers.find(
        (key: any) => key.right_flag === true
      )
      return correctAnswer.answer
    }
    const accordionTexts = []
    if (props.data.commentary) {
      accordionTexts.push({
        head: '解答・解説',
        body: props.data.commentary
      })
    }
    if (props.data.commentary_point) {
      accordionTexts.push({
        head: '解法のポイント',
        body: props.data.commentary_point
      })
    }

    return {
      isCorrect,
      correctAnswerText,
      accordionTexts
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.answerCommentaryItem {
  + & {
    margin-top: 56px;
  }

  h3 {
    font-weight: 500;
    font-size: 1.8rem;
    line-height: 1.34;
    padding-left: 9px;
    border-left: 4px solid var.$color-main;
  }

  .question {
    font-size: 1.8rem;
    line-height: 1.72;
    margin-top: 24px;
    font-weight: 500;
    white-space: pre-wrap;
    word-wrap: break-word;
    @include mixins.media() {
      font-size: 2rem;
    }
  }
  .img {
    margin-top: 32px;
    text-align: center;
    @include mixins.media() {
      margin-top: 40px;
    }
    img + img {
      margin-top: 16px;
    }
  }
  .result {
    margin-top: 32px;
    height: 60px;
    padding: 13px 0 15px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 2.2rem;
    font-weight: bold;
    @include mixins.media() {
      margin-top: 40px;
    }
    span {
      margin-top: -3px;
    }
    &.-correct {
      background-color: var.$color-sub-bg-g;
      color: var.$color-main-text;
      .icon {
        width: 22px;
        height: 22px;
        border: 3px solid var.$color-main;
        border-radius: 50%;
        margin-right: 8px;
      }
    }
    &.-incorrect {
      background-color: var.$color-bg-red;
      color: var.$color-primary;
      .icon {
        position: relative;
        width: 19px;
        height: 19px;
        margin-right: 8px;
        &::before,
        &::after {
          position: absolute;
          top: 50%;
          height: 2px;
          content: '';
          display: block;
          width: 100%;
          background-color: var.$color-primary;
        }
        &::before {
          transform: translateY(-50%) rotate(45deg);
        }
        &::after {
          transform: translateY(-50%) rotate(135deg);
        }
      }
    }
  }
  .answers {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-top: 12px;
    @include mixins.media() {
      margin-top: 16px;
    }
    .correct {
      font-size: 1.6rem;
      color: var.$color-primary;
      line-height: 1.93;
      font-weight: 500;
      flex-basis: 100%;
      margin-bottom: 10px;
      @include mixins.media() {
        margin-bottom: 0;
        flex-basis: auto;
        margin-right: 16px;
      }
    }
    .answer {
      font-size: 1.4rem;
      font-weight: bold;
      padding: 5px 10px;
      border-radius: 3px;
      background-color: var.$color-other-bg;
    }
  }
  .accordions {
    margin-top: 32px;
    @include mixins.media() {
      margin-top: 40px;
    }
    .accordion {
      + .accordion {
        margin-top: 16px;
        @include mixins.media() {
          margin-top: 20px;
        }
      }
    }
  }
}
</style>
